import React from 'react';
import ProfileDropdown from './ProfileDropdown';

const MobileTopBar = ({ onMenuToggle, user }) => {
  return (
    <div className="lg:hidden bg-white dark:bg-black sticky top-0 z-40">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Left: Hamburger Menu + Logo */}
        <div className="flex items-center space-x-3">
          <button
            onClick={onMenuToggle}
            className="p-2 rounded-lg text-gray-500 dark:text-[#666666] hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-[#1A1A1A] transition-colors"
            aria-label="Open menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          {/* Logo */}
          <div className="flex items-center space-x-1">
            <h1 className="text-sm tracking-wider text-gray-900 dark:text-white font-medium">
              K L O R A H
            </h1>
            <span className="px-1.5 py-0.5 text-[8px] bg-brand/10 rounded text-gray-500 dark:text-[#999999] font-medium">
              PRO
            </span>
          </div>
        </div>

        {/* Right: Profile Dropdown */}
        <div className="flex items-center">
          <ProfileDropdown user={user} />
        </div>
      </div>
    </div>
  );
};

export default MobileTopBar; 